import { connect } from "react-redux";
import _ from "lodash";

import { fetchUserProfile } from "src/redux/actions/users"; 
import {
  fetchContactShareAnanlytics,
  fetchAssetAnalytics,
  fetchContactByEmail,
  fetchShareSection,
} from "src/legacy/redux/actions/rolodex";
import withUseHooks from "src/legacy/components/withUseHooks";

import ContactConversationView from "./view";
import { fetchContactById, invalidateHubspotContact } from "src/redux/actions/integrations/hubspot";

const mapStateToProps = (state, ownProps) => {
  const shares = _.get(state,"legacyRootReducer.rolodex.contact.shares");
  const email = window.location.pathname.split('/')[4];

  return {
    id: email,
    contact: _.get(state,"legacyRootReducer.rolodex.contact.item"),
    shares: shares.items,
    loadingContact: _.get(state,"legacyRootReducer.rolodex.contact.loading"),
    isFetchingContactEmail: _.get(state,"integrations.hubspot.contact.loading"),
    loadingShares: shares.loading,
    loading: shares.loading || _.get(state,"legacyRootReducer.rolodex.loading"),
    currentPage: (shares.pagination && shares.pagination.current) || 0,
    totalPages: (shares.pagination && shares.pagination.totalPages) || 0,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchContactShareAnanlytics: (id, page) => {
      dispatch(fetchContactShareAnanlytics(id, page));
    },

    fetchContactById: (contactID) => {
      dispatch(fetchContactById(contactID));
    },

    fetchAssetAnalytics: (contactID, shareID, sectionID, assetID) => {
      return dispatch(
        fetchAssetAnalytics(contactID, shareID, sectionID, assetID)
      );
    },

    fetchUserProfile: () => {
      dispatch(fetchUserProfile());
    },

    fetchData: (email) => {
      return dispatch(fetchContactByEmail(email));
    },

    fetchShareSection: (contactId, shareId, sectionId) => {
      return dispatch(fetchShareSection(contactId, shareId, sectionId));
    },

    invalidateHubspotContact: () => {
      return dispatch(invalidateHubspotContact());
    }
  };
};

const HubspotContactConversationsContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ContactConversationView);

export default withUseHooks(HubspotContactConversationsContainer);